import React, { useContext } from 'react'
import { H3, Separator } from './SharingAndPermissions.styles'
import InvitePeople from './InvitePeople'
import ShareMemberships from './ShareMemberships'
import { WorkspacePermissions } from './WorkspacePermissions'
import { getApolloContext } from 'react-apollo'
import { readShareListItemFromCache } from 'modules/shares/graphql/cache'
import { dataIdFromObject } from 'graphql/cache'
import { ShareForSettingsModal } from './types'

/**
 * Types
 */
interface SharingAndPermissionsProps {
  share: Pick<
    ShareForSettingsModal,
    | 'identifier'
    | 'publicUrl'
    | 'publicAccessLevel'
    | 'publicCommentsEnabled'
    | 'userCanUpdateCommentsEnabled'
    | 'allowedPrivateAccessLevels'
    | 'allowedWorkspaceAccessLevels'
    | 'libraryEnabled'
    | 'workspaceAccessLevel'
    | 'workspaceCommentsEnabled'
    | 'userCanUpdateWorkspacePermissions'
    | 'isDraft'
    | 'workspace'
    | 'name'
  >
}

/**
 * Component
 */
const SharingAndPermissions = ({ share }: SharingAndPermissionsProps) => {
  const { client: apolloClient } = useContext(getApolloContext())
  const cache = apolloClient?.cache

  if (cache) {
    share =
      readShareListItemFromCache({
        cache,
        id: dataIdFromObject(share) as string,
      }) ?? share
  }

  return (
    <>
      <H3>Invite People</H3>
      <InvitePeople share={share} />
      <Separator mt={5} />
      <H3>Manage Access</H3>
      {share.userCanUpdateWorkspacePermissions && (
        <>
          <WorkspacePermissions share={share} />
          <Separator mt={5} />
        </>
      )}
      <ShareMemberships share={share} />
    </>
  )
}
export default SharingAndPermissions
